"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
const glide_1 = __importDefault(require("@glidejs/glide"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_easy_lightbox_1 = __importDefault(require("vue-easy-lightbox"));
const front_1 = require("../../../dsl/front");
const _filters_1 = require("../../_filters");
const ImageWithCaption_1 = require("../ImageWithCaption");
const composition_api_1 = require("@vue/composition-api");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let Gallery = class Gallery extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the arrows (control buttons) are currently hidden.
         */
        this.arrowsHidden = false;
        /**
         * Glide instance.
         */
        this.glide = null;
        this.visibleRef = composition_api_1.ref(false);
        this.indexRef = composition_api_1.ref(0);
        this.showImg = (index) => {
            this.indexRef.value = index;
            this.visibleRef.value = true;
        };
    }
    /**
     * Prepares gallery images
     */
    get preparedGallery() {
        return [...this.images.map((image, index) => {
                return _filters_1.prepareImage(image, null, this.maxWidth, index > 0);
            })];
    }
    /**
     * Prepares gallery images
     */
    get preparedGalleryLightbox() {
        const nGallery = [];
        this.preparedGallery.map((image, index) => {
            const nImage = { ...image, ...{ thumb: { ...image } } };
            nImage.src = (image.fullscreen) ? image.fullscreen : image.src;
            nGallery.push(nImage);
        });
        return nGallery;
    }
    /**
     * Closes full screen view of image
     */
    closeFullScreenPreview() {
        this.visibleRef.value = false;
    }
    /**
     * Handles the `@click` event on the root component's HTML element.
     */
    onClick() {
        if (this.arrowsHidden) {
            this.showArrows();
        }
    }
    /**
     * Hides the arrows (control buttons).
     */
    hideArrows() {
        this.arrowsHidden = true;
    }
    /**
     * Initialises the Glide.
     */
    initGlide() {
        this.glide = new glide_1.default(`#${this.$id()}`);
        this.glide.on('build.after', () => {
            if (this.windowService.isPhone) {
                this.hideArrows();
            }
        });
        this.glide.mount();
    }
    /**
     * Shows the arrows (control buttons).
     */
    showArrows() {
        this.arrowsHidden = false;
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], Gallery.prototype, "fullScreen", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", String)
], Gallery.prototype, "imageClasses", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Number,
        required: false,
        default: 800
    }),
    __metadata("design:type", Number)
], Gallery.prototype, "maxWidth", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Array,
        required: true
    }),
    __metadata("design:type", Array)
], Gallery.prototype, "images", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], Gallery.prototype, "windowService", void 0);
Gallery = __decorate([
    vue_property_decorator_1.Component({
        name: 'Gallery',
        components: {
            BootstrapIcon: front_1.BootstrapIcon,
            ImageWithCaption: ImageWithCaption_1.ImageWithCaption,
            VueEasyLightbox: vue_easy_lightbox_1.default
        },
        filters: { prepareImage: _filters_1.prepareImage },
        mounted() {
            if (this.images && this.images.length) {
                this.initGlide();
            }
            else {
                const unwatch = this.$watch('images', () => {
                    this.initGlide();
                    unwatch();
                });
            }
        },
        template: `
    <div v-if="(images && images.length)" class="gallery glide" :id="$id()" @click.once="onClick">
    <!-- Slides -->
    <div class="glide__track" data-glide-el="track">
      <ul class="glide__slides list-unstyled">
        <li v-for="(image, index) in preparedGalleryLightbox" :key="index" class="glide__slide">
          <ImageWithCaption :image="image.thumb" :class="imageClasses" @click="()=>showImg(index)"/>
        </li>
      </ul>
    </div>
    <!-- END | Slides -->

    <VueEasyLightbox
      v-if="fullScreen"
      :index="indexRef.value"
      :visible="visibleRef.value"
      :imgs="preparedGalleryLightbox"
      @hide="closeFullScreenPreview"
    />

    <!-- Controls -->
    <div class="glide__arrows" :class="{ '--hidden': arrowsHidden }" data-glide-el="controls">
      <button class="glide__arrow glide__arrow--left" data-glide-dir="<">
        <BootstrapIcon name="arrow"/>
        <span class="visually-hidden">Poprzedni slajd</span>
      </button>
      <button class="glide__arrow glide__arrow--right" data-glide-dir=">">
        <BootstrapIcon name="arrow"/>
        <span class="visually-hidden">Następny slajd</span>
      </button>
    </div>
    <!-- END | Controls -->
    </div>
  `
    })
], Gallery);
exports.Gallery = Gallery;
//# sourceMappingURL=Gallery.js.map